export class FiltroBuscaPaginacao {

    page: number;
    pageSize: number;

    constructor(page: number, pageSize : number) {
        this.pageSize = pageSize;
        this.page = page;
    }
}





// WEBPACK FOOTER //
// ./src/app/shared/filter/filtro-busca-paginacao.ts